// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"TwoPointResizable\"] .dot {\n    cursor: pointer;\n    fill: #fff;\n    transition: fill 100ms ease-in-out, r 100ms ease-in-out;\n    r: 4;\n  }\n    [name=\"TwoPointResizable\"] .dot:hover {\n      fill: #ddd;\n      r: 5;\n    }\n    [name=\"TwoPointResizable\"] .dot:active {\n      fill: #bbb;\n      r: 5;\n    }", ""]);
// Exports
module.exports = exports;
